import React, { useState, useEffect, useCallback } from "react";
import DashboardNav from "../DashboardNavbar/DashboardNav";
import {
  deleteDeliveryPersonnel,
  getAlldeliveryPersonnel,
} from "../../api/Api";
import {
  Box,
  Typography,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
  TablePagination,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddDeliveryPersonModal from "../../components/modal/AddDeliveryPersonModal";
import AddAreasModal from "../../components/modal/AddAreasModal";
import UpdateDeliveryPersonModal from "../../components/modal/UpdateDeliveryPersonModal";
import UniversalModal from "../../components/modal/UniversalModal";

const DeliveryPersonDashboard = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [personnel, setPersonnel] = useState([]);
  const [deletingUser, setDeletingUser] = useState(null);

  const [openAddModal, setOpenAddModal] = useState(false);
  const [openAddRegionModal, setOpenAddRegionModal] = useState(false); // Add Region modal state
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [isUniversalModalOpen, setIsUniversalModalOpen] = useState(false);
  const [info, setInfo] = useState("");

  const [selectedUser, setSelectedUser] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchDeliveryPersonnel = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAlldeliveryPersonnel();
      const deliveryPersonnel = response.data.data;
      setPersonnel(deliveryPersonnel);
    } catch (error) {
      console.error("Error fetching delivery personnel:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDeliveryPersonnel();
  }, [fetchDeliveryPersonnel]);

  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleCloseAddModal = () => {
    setOpenAddModal(false);
    fetchDeliveryPersonnel();
  };

  const handleOpenAddRegionModal = () => setOpenAddRegionModal(true);
  const handleCloseAddRegionModal = () => setOpenAddRegionModal(false);

  const handleOpenUpdateModal = (user) => {
    setSelectedUser(user);
    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = () => setOpenUpdateModal(false);

  const handleUpdateUser = (updatedUser) => {
    if (JSON.stringify(updatedUser) !== JSON.stringify(selectedUser)) {
      setInfo("Updated successfully");
      setIsUniversalModalOpen(true);
      fetchDeliveryPersonnel();
    }
  };

  const handleDelete = async (email) => {
    setDeletingUser(email);
    try {
      await deleteDeliveryPersonnel(email);
      setPersonnel((prev) => prev.filter((user) => user.email !== email));
      setInfo("Deleted Person successfully");
      setIsUniversalModalOpen(true);
    } catch (error) {
      console.error("Error deleting user:", error);
    } finally {
      setDeletingUser(null);
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAddSuccess = () => {
    setInfo("Delivery personnel Added successfully");
    setIsUniversalModalOpen(true);
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <DashboardNav />
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "180px",
          left: 0,
          right: 0,
          px: 1,
          width: "90vw",
          margin: "auto",
          color: "#888585",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "500",
            fontSize: "32px",
            fontFamily: theme.typography.fontFamily,
          }}
          gutterBottom
        >
          Delivery Person Dashboard
        </Typography>

        <Grid
          container
          justifyContent="end"
          sx={{ mb: 2, height: "3rem" }}
        >
          {/* <Button
            variant="contained"
            sx={{
              backgroundColor: theme.palette.primary.light,
              height: "100%",
              color: "#fff",
              textTransform: "capitalize",
              margin:"10px",
              "&:hover": { backgroundColor: "#0056b3" },
            }}
            onClick={handleOpenAddRegionModal}
          >
            Add Region
          </Button> */}

          <Button
            variant="contained"
            sx={{
              backgroundColor:theme.palette.primary.light,
              height: "100%",
              color: "#fff",
              textTransform: "capitalize",
              margin:"10px",
              "&:hover": { backgroundColor: "#2E7D32" },
            }}
            onClick={handleOpenAddModal}
          >
            Add Delivery Person
          </Button>
        </Grid>

        <AddDeliveryPersonModal
          open={openAddModal}
          handleClose={handleCloseAddModal}
          onSuccess={handleAddSuccess}
        />
        <AddAreasModal
          open={openAddRegionModal}
          handleClose={handleCloseAddRegionModal}
          onSuccess={(regionData) => {
            setInfo(`Region Added Succesfully`);
            setIsUniversalModalOpen(true);
          }}
        />
        <UpdateDeliveryPersonModal
          open={openUpdateModal}
          handleClose={handleCloseUpdateModal}
          userData={selectedUser}
          handleUpdateUser={handleUpdateUser}
        />

        {/* Table Content and Pagination */}
        <TableContainer component={Paper} sx={{ mt: 4 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor:theme.palette.primary.light}}>
                {["Sl No", "Name", "Area", "Contact No", "Email", "Actions"].map(
                  (heading, idx) => (
                    <TableCell
                      key={idx}
                      sx={{ color: "#fff", textAlign: "center" }}
                    >
                      {heading}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading
                ? Array.from(new Array(5)).map((_, index) => (
                    <TableRow key={index}>
                      {[50, 100, 80, 100, 150, 80].map((width, idx) => (
                        <TableCell key={idx} align="center">
                          <Skeleton variant="text" width={width} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                : personnel.length > 0
                ? personnel
                    .slice()
                    .reverse()
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((person, index) => (
                      <TableRow key={person._id}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">{person.name}</TableCell>
                        <TableCell align="center">{person.area}</TableCell>
                        <TableCell align="center">
                          {person.phone_number}
                        </TableCell>
                        <TableCell align="center">{person.email}</TableCell>
                        <TableCell align="center">
                          <Button
                            variant="outlined"
                            sx={{
                              color: "#fff",
                              backgroundColor: "#FF893A",
                              "&:hover": { backgroundColor: "#FF879A" },
                              marginRight: 1,
                              textTransform: "capitalize",
                            }}
                            onClick={() => handleOpenUpdateModal(person)}
                          >
                            Update
                          </Button>
                          <Button
                            variant="outlined"
                            sx={{
                              color: "#fff",
                              backgroundColor: "#FF5252",
                              "&:hover": { backgroundColor: "#FF1744" },
                              textTransform: "capitalize",
                            }}
                            onClick={() => handleDelete(person.email)}
                          >
                            {deletingUser === person.email
                              ? "Please wait..."
                              : "Delete"}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No personnel available.
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={personnel.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      <UniversalModal
        open={isUniversalModalOpen}
        onClose={() => setIsUniversalModalOpen(false)}
        message={info}
      />
    </Box>
  );
};
export default DeliveryPersonDashboard;
